module.exports = __webpack_public_path__ + "static/media/homepage-title.02a59147.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage-title.svg
// module id = 1586
// module chunks = 27